import extend from 'lodash/extend';

import Observable from '../../lib/ObservableMixin.js';

export default class MessageGatewayBase {
  requestSession() {
    throw new Error('request function is not implemented');
  }

  onFetchResponse() {
    throw new Error('onFetchResponse function is not implemented');
  }

  onFetchError() {
    throw new Error('onFetchError function is not implemented');
  }

  sendMessage() {
    throw new Error('add function is not implemented');
  }

  onSendMessageSuccess() {
    throw new Error('onAddSuccess function is not implemented');
  }

  onMessageReceived() {
    throw new Error('onMessageReceived function is not implemented');
  }

  handleEntity() {
    throw new Error('handleEntity function is not implemented');
  }

  updateCustomerTypingState() {
    throw new Error('updateCustomerTypingState function is not implemented');
  }

  updateCustomerUrl() {
    throw new Error('updateCustomerUrl function is not implemented');
  }

  updateWelcomeMessage() {
    throw new Error('updateWelcomeMessage function is not implemented');
  }
}

extend(MessageGatewayBase.prototype, Observable);
